import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    TableActionIconEmail,
    TableActionIconChart,
    TableActionIconDelete,
    TableActionIconEdit,
    TableActionIconPassword,
    TableActionIconActivate,
    TableActionIconSuspend,
    TableActionIconView
} from "./BaseTableComponents";

import './Table.scss'
import {getUsersRouterLink} from "root/Wieldy/routePaths";

const ChildrenTable = (props) =>
{
    const onClickItem = (user_id, mode, role) =>
    {
        props.clickHandler(user_id,  mode, role);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const link = getUsersRouterLink(row.idusers + '/connections?name=' + row.name);
        const dashboardLink = getUsersRouterLink(row.idusers + '/dashboard?type=summary&name=' + row.name + '&userType=' + row.userTypeId);

        return (
            <Fragment>
                <TableActionIconView text="Manage Child's Connections" to={link} />
                <TableActionIconChart text="View Stats" to={dashboardLink} />
                <TableActionIconEdit text="Edit Child" onClick={() => onClickItem(row.idusers,'edit',  row.typeName)} />
                <TableActionIconPassword text="Change Password" onClick={() => onClickItem(row.idusers, 'password')} />

                { (row.us_description === 'Invited' || row.us_description === 'Re-invited' || row.us_description === 'Expired') && <TableActionIconEmail text="Invite Again" onClick={() => onClickItem(row.idusers, 'invite')} />}
                { row.us_description === 'Active' && <TableActionIconSuspend text="Suspend Child" onClick={() => onClickItem(row.idusers, 'suspend')} />}
                { row.us_description === 'Suspended' && <TableActionIconActivate text="Activate Child" onClick={() => onClickItem(row.idusers, 'activate')} />}

                <TableActionIconDelete text="Archive User" onClick={() => onClickItem(row.idusers, 'delete')} />
            </Fragment>
        );
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let color = "#216C06";

        if (cell === "Suspended" || cell === "Expired") {color = "#E00909";}

        if (cell === "Invited" || cell === "Re-invited") {color = "#E1720B";}

        return <div style={{ borderRadius: "5px", color: color }}>{cell}</div>;
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle, width: "15vw"},
        surname: { width: "15vw"},
        username: {width: "15vw"},
        acs_status: {width: "6vw"},
        formatted_dob: {width: "6vw"},
        options: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "15vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "firstname",
                text: "Firstname",
                headerStyle: headerStyle
            },
            {
                dataField: "surname",
                text: "Surname",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "username",
                text: "Username",
                headerStyle: headerStyle
            },
            {
                dataField: "description",
                text: "Short Name",
                headerStyle: headerStyle
            },
            {
                dataField: "formatted_dob",
                text: "DOB",
                headerStyle: headerStyle
            },
            {
                dataField: "us_description",
                text: "Account Status",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "acs_status",
                text: "Care Status",
                headerStyle: headerStyle
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default ChildrenTable;

ChildrenTable.propTypes = {
    user_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};
